<template>
  <div class="" v-if="variations.length != 0">
    <h3>تنوع</h3>
    <b-button v-b-modal.choose-variations>افزودن تنوع</b-button>

    <b-modal id="choose-variations" title="" hide-footer>

      <select class="custom-select" v-model="selectedVariationType">
        <option v-for="item in variations" :value="item">{{ item.title }}</option>
      </select>


      <div class="row text-right" v-if="selectedVariationType">
        <div class="btn  rounded-pill m-1 border" v-for="item in selectedVariationType.values"
             @click="setSelectedVariation(item)">
          <span>{{ item.title }}</span>
        </div>
      </div>


    </b-modal>

    <div class="col-12">
      <div class="row align-items-center" v-for="(item,index) in selectedVariations" :key="index">
        <div class="col-lg-2">
          <span>{{ item.title }}</span>
        </div>
        <div class="col-lg-3">
          <div class="form-group">
            <label :for="`variation_${item.id}_primary_price`">قیمت اصلی</label>
            <input v-model="item.primary_price" required type="number" class="text-left form-control"
                   :id="`variation_${item.id}_primary_price`">
            {{formatNumber(item.primary_price)}}
          </div>
        </div>
        <div class="col-lg-3">
          <div class="form-group">
            <label :for="`variation_${item.id}_price`">قیمت با تخفیف(اختیاری)</label>
            <input v-model="item.price" type="number" class="text-left form-control" :id="`variation_${item.id}_price`">
            {{formatNumber(item.price)}}
          </div>
        </div>
        <div class="col-lg-3">
          <div class="form-group">
            <label :for="`variation_${item.id}_quantity`">تعداد</label>
            <input v-model="item.stock" required type="number" class="text-left form-control"
                   :id="`variation_${item.id}_quantity`">
          </div>
        </div>
        <div class="col-lg-1">
          <b-icon icon="trash" @click="removeVariations(index)" class="h4"/>
        </div>
        <hr>
      </div>
    </div>


  </div>
</template>

<script>

import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "BasalamVariation",
  props: {
    category: {
      default: null
    },
    basalamProduct: {
      default: null
    }
  },
  data() {
    return {
      variations: [],
      selectedVariations: [],
      selectedVariationType: null
    }
  },
  computed: {},
  methods: {
    formatNumber,
    async getVariations() {
      let form = {
        id: this.category.id
      }
      let req = await this.$store.dispatch('Basalam/getCategoryVariations', form)

      let data = req.data.data

      if (data) {
        this.variations = data
        return true
      }

      this.variations = []
      return true
    },
    setSelectedVariation(item) {
      let selectedItemsId = this.selectedVariations.map(item => item.id)
      if (selectedItemsId.indexOf(item.id) == -1) {
        this.selectedVariations.push({

          id: item.id,
          title: item.title,
          property: item.title == 'سایز' ? 'size' : 'color',
          value: item.value,
          price: 0,
          primary_price: 0,
          stock: 0,
          properties: [
            {
              property_id: this.selectedVariationType.id,
              value_id: item.id
            }
          ],

        })
        return true
      }
      toast('قبلا انتخاب شده است', 'قبلا انتخاب شده است', 'danger')
      return false
    },
    convertRealToToman(value) {

      if (value.length == 0 || value == '' || value == 0 || value == null) {
        return value
      }

      return (value / 10)
    },
    setSelectedVariationFromBasalam() {
      let variations = this.basalamProduct.variants

      if (variations == null) {
        this.selectedVariations = []
        return false
      }

      variations.forEach(item => {


        this.selectedVariations.push({
          id: item.properties[0].value.id,
          title: item.properties[0].value.title,
          property: item.properties[0].property.title == 'رنگ' ? 'color' : '',
          value: item.properties[0].value.value,
          price: this.convertRealToToman(item.price),
          primary_price: this.convertRealToToman(item.primary_price),
          price_with_discount: this.convertRealToToman(item.price),
          stock: item.stock,
          properties: [
            {
              property_id: item.properties[0].property.id,
              value_id: item.properties[0].value.id
            }
          ],
        })
      })

    },
    removeVariations(index) {
      if (confirm('ایا از حذف ایتم اطمینان دارید؟')) {
        this.selectedVariations.splice(index, 1)
      }
    }
  },

  watch: {
    category: {
      handler(newValue, oldValue) {
        this.getVariations()
        if (this.basalamProduct != null) {
          this.setSelectedVariationFromBasalam()
        }
      },
      deep: true
    },
    selectedVariations: {
      handler(newValue, oldValue) {
        this.$emit('variations', this.selectedVariations)
      },
      deep: true
    }
  }
}
</script>


<style scoped>

</style>